<template>
  <v-data-table v-bind:headers="headers" v-bind:items="modifiers">
    <template v-slot:item.action="{item}">
      <v-checkbox v-model="item.considered" color="success"/>
    </template>
  </v-data-table>
</template>
<script>
export default {
  name: 'v-salary-discounts-view',
  data: () => ({
    headers: [
      {text: 'Description', value: 'description', sortable: false},
      {text: 'Type', value: 'type', sortable: false, width: 120},
      {text: 'Date', value: 'date', sortable: false, width: 120},
      {text: 'Amount', value: 'amount', sortable: false, width: 100},
      {text: 'Consider', value: 'action', sortable: false, width: 80},
    ],
    modifiers: [
      {description: 'Do not come to work', type: 'penalty', date: '06-03-2020', amount: 590000},
      {description: 'Do not come to work', type: 'penalty', date: '07-03-2020', amount: 590000},
      {description: 'Do not come to work', type: 'penalty', date: '08-03-2020', amount: 590000},
    ]
  })
}
</script>
